import classNames from "classnames/bind";
import styles from './ListServices.module.css';
import ServicesPack from "./ServicePack";
import ActImage from '../../../../assets/images/detect-action.png';
import FaceImage from '../../../../assets/images/detect-face.png';
import HumanImage from '../../../../assets/images/detect-human.png';
import { Fragment, useEffect, useState } from "react";
import axiosClient from "../../../../services/axiosClient";
import CloudImage from "../../../../assets/images/cloud.png";
import { Col, Row, Toast } from "../../../../components";
// import { listServiceCamServiceAPI } from "../../../../services/api/listServiceCamServiceAPI";
import { listServiceCamServiceAPI } from "../../../../services/api/listServiceCamServiceAPI";


const cx = classNames.bind(styles)

// const mockCloud = [
//     {
//         image: CloudImage,
//         CODE: '111',
//         SUBJECT_NAME: 'iCloud lưu trữ',
//         COST: 50000,
//         custom: true,
//         STATUS: 'Chưa đăng ký',
//         SPACE: '3GB-100GB',
//     }
// ]

function ListServices() {
    const [service, setService] = useState([])
    // useEffect(() => {
    //     const getData = async () => {
    //         try {
    //             const res = await axiosClient.get('/service/get-list-services/', {
    //                 registered: 0
    //             })
    //             setService(res)
    //             // // console.log('red', res);
    //         } catch (error) {
    //             if (error?.response?.status === 403) {
    //                 Toast.open('Bạn không có quyền xem dịch vụ', 'danger')
    //             } else {
    //                 Toast.open('Không thể xem danh sách dịch vụ', 'danger')
    //             }
    //         }
    //     }
    //     getData()
    // }, [])
    useEffect(() => {
        const getData = async () => {
            try {
                const res = await listServiceCamServiceAPI.get();
                const services = res?.data?.map((item) => {
                    return {
                        ALLOW_CONFIG: "Có",
                        CODE: item?.code,
                        COST: "500000",
                        STATUS: "Chưa đăng ký",
                        SUBJECT_NAME: item?.subjectName
                    }
                })
                setService(services)
            } catch (error) {
                if (error?.response?.status === 403) {
                    Toast.open('Bạn không có quyền xem dịch vụ', 'danger')
                } else {
                    Toast.open('Không thể xem danh sách dịch vụ', 'danger')
                }
            }
        }
        getData();
    }, [])
    return (
        // <div className={cx('wrapper')}>
        <Fragment>
            <div id="__notification"></div>
            <Row gap={[8, 8]}>
                {service && service.map((item, index) => {
                    return (
                        <Col span={3} key={index}>
                            <ServicesPack
                                key={index}
                                code={item.CODE}
                                name={item.SUBJECT_NAME}
                                price={item.COST / 1000}
                                event={item.SUBJECT_NAME}
                                custom={item.custom}
                                status={item.STATUS}
                                image={item.SUBJECT_NAME === 'Nhận diện khuôn mặt' ? (FaceImage) :
                                    item.SUBJECT_NAME === 'Phát hiện người' ? (HumanImage) :
                                        item.SUBJECT_NAME === 'Phát hiện chuyển động' ? (ActImage) : (ActImage)
                                }
                            />
                        </Col>
                    )
                })}
            </Row>
            {/* {mockCloud.map((cloud) => {
                return (
                    <ServicesPack
                        key={cloud.CODE}
                        code={cloud.CODE}
                        name={cloud.SUBJECT_NAME}
                        price={cloud.COST / 1000}
                        event={cloud.SUBJECT_NAME}
                        custom={cloud.custom}
                        status={cloud.STATUS}
                        image={cloud.image}
                        space={cloud.SPACE}
                    />
                )
            })} */}
        </Fragment>
    )
}

export default ListServices;